import { useMutation } from 'data-fetching-client';
import { useDispatch } from 'react-redux';
import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { GET_PREFERRED_CURRENCY, UPDATE_PREFERRED_CURRENCY } from '../../../api/dataFetchingQueries';
import { fetchAggregatedOverviewData } from '../../../actions/AggregatedOverviewDataActions';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
const useUpdatePreferredCurrency = () => {
  const dispatch = useDispatch();
  const [updatePreferredCurrency] = useMutation(UPDATE_PREFERRED_CURRENCY);
  return currency => updatePreferredCurrency({
    variables: {
      currencyCode: currency
    },
    update(cache, _, newData) {
      if (newData.variables && newData.variables.currencyCode) {
        cache.writeQuery({
          query: GET_PREFERRED_CURRENCY,
          data: {
            preferredCurrency: {
              preferredCurrency: newData.variables.currencyCode
            }
          }
        });
      }
    }
  }).then(() => {
    FloatingAlertStore.addAlert({
      message: I18n.text('multicurrencyPanel.save.success.message'),
      titleText: I18n.text('multicurrencyPanel.save.success.title'),
      type: 'success'
    });
    dispatch(fetchAggregatedOverviewData()).catch(error => logRavenException(error, 'Fetch aggregated overview data after updating preferred currency'));
  }).catch(error => {
    FloatingAlertStore.addAlert({
      message: I18n.text('multicurrencyPanel.save.error.message'),
      titleText: I18n.text('multicurrencyPanel.save.error.title'),
      type: 'danger'
    });
    logRavenException(error, 'Update preferred currency', {
      currency
    });
  });
};
export default useUpdatePreferredCurrency;